module.exports = __webpack_public_path__ + "static/media/toolbar-hand.2f9124ab.svg";